import { render, staticRenderFns } from "./UnitsDialog.vue?vue&type=template&id=4b0d735e&scoped=true"
import script from "./UnitsDialog.vue?vue&type=script&lang=js"
export * from "./UnitsDialog.vue?vue&type=script&lang=js"
import style0 from "./UnitsDialog.vue?vue&type=style&index=0&id=4b0d735e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d735e",
  null
  
)

export default component.exports